import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Check as CheckIcon } from '@material-ui/icons';

import Loader from 'common/components/Loader';
import useProjectSearch from './hooks/useProjectSearch';

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';

const styles = {
  table: {
    width: '100%',
  },
  keyword: {
    fontWeight: 'bolder',
    textDecoration: 'underline',
  },
  row: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
  selectedCell: {
    fontWeight: 'bolder',
    color: '#45a7dc',
  },
  headRow: {
    fontWeight: 'bolder',
    textTransform: 'uppercase',
    background: 'transparent',
    '&:nth-child(1)': {
      width: '10%',
    },
    '&:nth-child(2)': {
      width: '85%',
    },
    '&:nth-child(3)': {
      width: '5%',
      textAlign: 'center',
    },
  },
  chk: {
    opacity: 0,
  },
  chkSelected: {
    opacity: 1,
    color: '#45a7dc',
  },
  loaderContainer: {
    height: 100,
  },
  noResultsContainer: {
    textAlign: 'center',
  },
};

const ProjectList = props => {
  const {
    classes,
    to,
    keyword = '',
    environment = '',
    onSelect = () => {},
  } = props;

  const validKeyword = keyword.length > 1;
  const validEnvironment = environment.length > 0;
  const [selectedProject, setSelectedProject] = useState(null);
  const { loading, data: projects } = useProjectSearch(
    to,
    keyword,
    environment,
  );

  if (!validKeyword || !validEnvironment) return <div />;
  if (loading) {
    return (
      <div className={classes.loaderContainer}>
        <Loader />
      </div>
    );
  }

  const handleRowClick = project => {
    if (selectedProject === project.id) {
      setSelectedProject(null);
      onSelect(null, environment);
    } else {
      setSelectedProject(project.id);
      onSelect(project, environment);
    }
  };

  const projectRow = project => {
    const { id, name } = project;
    const selected = project.id === selectedProject;
    let cellClass = selected ? classes.selectedCell : classes.row;

    return (
      <TableRow
        data-test-id={`ProjectList-project-${id}`}
        className={classes.row}
        key={id}
        onClick={() => {
          handleRowClick(project);
        }}
      >
        <TableCell className={cellClass}>{id}</TableCell>
        <TableCell className={cellClass}>{name}</TableCell>
        <TableCell className={cellClass}>
          <CheckIcon className={selected ? classes.chkSelected : classes.chk} />
        </TableCell>
      </TableRow>
    );
  };

  if (projects.length === 0) {
    return (
      <div className={classes.noResultsContainer}>
        No results for <span className={classes.keyword}>{keyword}</span>
      </div>
    );
  }

  return (
    <Table className={classes.table} stickyHeader>
      <caption>Please select a project to continue.</caption>
      <TableHead>
        <TableRow>
          <TableCell className={classes.headRow}>Id</TableCell>
          <TableCell className={classes.headRow}>Name</TableCell>
          <TableCell className={classes.headRow} />
        </TableRow>
      </TableHead>
      <TableBody>{projects.length > 0 && projects.map(projectRow)}</TableBody>
    </Table>
  );
};

export default withStyles(styles)(ProjectList);
